import { MAIN_FRAME } from "../constants";

export const notifyParent = ({
  type,
  payload,
}: {
  type: string;
  payload: unknown;
}) => {
  // TODO: use parent origin instead of *
  parent.postMessage({ type, payload }, "*");
};

let cardFrame: Window | undefined;
export const findCardFrame = () => {
  if (cardFrame) {
    return cardFrame;
  }

  const frames = parent.frames;

  for (let i = 0; i < frames.length; i++) {
    const frame = frames[i];
    try {
      if (frame.name === MAIN_FRAME) {
        cardFrame = frame;
        break;
      }
    } catch (e) {}
  }

  return cardFrame;
};

export const getOrigin = () => location.origin;

export const notifyCard = (data: Record<string, unknown>) => {
  const cardFrame = findCardFrame();

  if (!cardFrame) {
    return;
  }

  cardFrame.postMessage(data, getOrigin());
};
